import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export interface ProductFeedbackPayload {
  opinion: "choice 1" | "choice 2";
  helpfulness: number;
  improve: string;
  experience?: string;
}

export const sendProductFeedback = async (
  accessAuthToken: string,
  payload: ProductFeedbackPayload
): Promise<{ success: boolean }> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/feedback/product`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    credentials: "include",
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const message = errorData.message || "Failed to send feedback. Please try again.";
    showErrorToast(message);
    throw new Error(message);
  }

  return response.json();
};
